import React, { Component } from 'react'

import PaperBlock from "./../ui/PaperBlock.js"

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import Screen from "../ui/Screen"
import ControlPanel from './DewarAccountingScreen/ControlPanel'
import DewarAccountingList from './DewarAccountingScreen/DewarAccountingList.js'

import CreateDialog from './DewarAccountingScreen/CreateDialog.js'
import EditDialog from './DewarAccountingScreen/EditDialog.js'
import DeleteDialog from './DewarAccountingScreen/DeleteDialog.js'

import api from "../api.js"
import SearchPanel from './DewarAccountingScreen/SearchPanel.js'

class DewarsAccountingScreen extends Component {

    constructor(props) {
        
        super(props)

        this.state = {
            dialog: undefined,
            screen: undefined,
            selected: undefined,
            dewars: [],
            code_filter: "",
            completion: "0",
            search_code: "",
        }

    }

	handle_error = (error) => {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
						.then(() => {this.setState({dialog: undefined})})
						.catch(this.handle_error)
				}}
			/>
		})
	}       

    update = async () => {
        try {
            let response = await api.dewars_accounting.list(this.state.completion, this.state.code_filter)
            this.setState({dewars: response.dewars})
        }
        catch (e) {
            this.handle_error(e)
        }
    }

    async componentDidMount() {
        await this.update()
    }    

    handle_Screen_onClick = (e) => {
        e.stopPropagation()
        if (!this.state.dialog) {
            this.setState({selected: undefined})
        }
    }

    handle_ControlPanel_onAddDewarClick = () => {
        this.setState({
            dialog: <CreateDialog 
                onCreateClick={async (dewar_id, user_id, comment) => {
                    await api.dewars_accounting.create(dewar_id, user_id, comment)
                    await this.update()
                    this.setState({dialog: undefined})
                }}
                onCancelClick={() => {
                    this.setState({dialog: undefined})
                }}
            />
        })
    }

    handle_ControlPanel_onDeleteDewarClick = (dewar) => {
		this.setState({
			dialog: <DeleteDialog
				dewar = {dewar}
				onDeleteDewarClick = {async (dewar) => {
                    try {
                        await api.dewars_accounting.delete(dewar.id)
                        await this.update()
                        this.setState({dialog: undefined, selected: undefined})
                    }
                    catch (e) {
                        this.handle_error(e)
                    }
				}}
				onCancelClick = {() => {
                    this.setState({dialog: undefined})
                }}
			/>
		})
    }

    handle_ControlPanel_onEditDewarClick = (dewar) => {
        this.setState({
            dialog: <EditDialog
                dewar={dewar}
                onEditClick={async (d) => {
                    if (d.user.id !== dewar.user.id) {
                        await api.dewars_accounting.update_user_id(dewar.id, d.user.id )
                    }
                    if (d.completion !== dewar.completion) {
                        if (d.completion === 1) {
                            await api.dewars_accounting.update_completion(dewar.id, 1)
                            await api.dewars_accounting.update_completion_date(dewar.id)
                        } else {
                            await api.dewars_accounting.update_completion(dewar.id, 0)
                        }
                    }
                    if (d.comment !== dewar.comment) {
                        await api.dewars_accounting.update_comment(dewar.id, d.comment)
                    }
                    await this.update()
                    this.setState({dialog: undefined})
                }}
                onCancelClick={() => {
                    this.setState({dialog: undefined})
                }}                
            />
        })
    }

    handle_ControlPanel_onFilter = (filter) => {
        this.setState({completion: filter}, this.update)
    }

    handle_DewarAccountingList_onClick = (dewar) => {
        if (this.state.selected && this.state.selected.id === dewar.id) {
            this.handle_ControlPanel_onEditDewarClick(dewar)
        } else {
            this.setState({selected: dewar})
        }
    }

    handle_DewarAccountingList_onCompletionClick = async (dewar) => {
        try {
            if (dewar.completion === 0) {
                await api.dewars_accounting.update_completion(dewar.id, 1)
                await api.dewars_accounting.update_completion_date(dewar.id)
            } else {
                await api.dewars_accounting.update_completion(dewar.id, 0)
            }
            await this.update()
        }
        catch(e) {
            this.handle_error(e)
        }
    }

    render() {

		if (this.state.screen) {
            return this.state.screen
        }

        return <Screen onClick = { this.handle_Screen_onClick } >

            {this.state.dialog}

            <ControlPanel 
				selected = {this.state.selected}
				onAddDewarClick = {this.handle_ControlPanel_onAddDewarClick}
				onEditDewarClick = {this.handle_ControlPanel_onEditDewarClick}
				onDeleteDewarClick = {this.handle_ControlPanel_onDeleteDewarClick}
                onFilter = {this.handle_ControlPanel_onFilter}
            />

            <SearchPanel
                code={this.state.search_code}
                onChange={async (e) => {
                    e.stopPropagation()
                    this.lastEnterTime = new Date().getTime()
                    if (!this.intervalId) {
                        this.intervalId = setInterval(() => {
                            if (this.lastEnterTime + 300 < new Date().getTime()) {
                                clearInterval(this.intervalId)
                                this.intervalId = undefined
                                this.setState({code_filter: this.state.search_code}, this.update)
                            }
                        }, 200)
                    }
                    this.setState({ 
                        search_code: e.target.value,
                    })
                }}
            />

            <PaperBlock style={{width: this.props.width_auto ? "auto" : "100%"}}>
                <DewarAccountingList 
                    dewars={this.state.dewars}
                    selected={this.state.selected}
                    onDewarClick={this.handle_DewarAccountingList_onClick}
                    onCompletionClick={this.handle_DewarAccountingList_onCompletionClick}
                />
            </PaperBlock>

        </Screen>
    
    }

}

export default DewarsAccountingScreen